module.exports = __webpack_public_path__ + "img/11n.80b97eb8.gif";